module.exports = __webpack_public_path__ + "img/remita.063f936a.png";